import {apolloClient} from '@/apollo'
import {
    ADD_NEW_CUSTOMER,
    ADD_NEW_CUSTOMER_BRANCH,
    ADD_NEW_SALES_PROFILE,
    ADD_SALES_PROFILE_COMMENTS,
    ADD_SALES_PROFILE_TURNOVER,
    ADD_SALES_PROFILE_VISITS,
    CHANGE_SALES_PROFILE_OWNERSHIP,
    UPDATE_CUSTOMER,
    UPDATE_CUSTOMER_BRANCH,
    UPDATE_SALES_PROFILE,
    UPDATE_CUSTOMER_STATUS
} from "@/gql/customers";

export const state = {
    loading: false,
    errors: [],
}
export const getters = {
    customerLoading: state => state.loading,
    customerErrors: state => state.errors
}
export const actions = {

    async addNewCustomer({commit}, customerData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {institution}} = await apolloClient.mutate({
                mutation: ADD_NEW_CUSTOMER,
                variables: customerData
            })
            return institution.institution
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async updateCustomer({commit}, customerData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {institution}} = await apolloClient.mutate({
                mutation: UPDATE_CUSTOMER,
                variables: customerData,
            })
            return institution.institution

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addNewCustomerBranch({commit}, branchData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {branch}} = await apolloClient.mutate({
                mutation: ADD_NEW_CUSTOMER_BRANCH,
                variables: branchData
            })
            return branch.branch
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async updateCustomerBranch({commit}, branchData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {branch}} = await apolloClient.mutate({
                mutation: UPDATE_CUSTOMER_BRANCH,
                variables: branchData,
            })
            return branch.branch

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addNewSalesProfile({commit}, profileData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {feedback}} = await apolloClient.mutate({
                mutation: ADD_NEW_SALES_PROFILE,
                variables: profileData
            })
            return feedback.feedback
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async updateSalesProfile({commit}, profileData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {feedback}} = await apolloClient.mutate({
                mutation: UPDATE_SALES_PROFILE,
                variables: profileData,
            })
            return feedback.feedback

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addNewSalesProfileComment({commit}, commentData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {thread}} = await apolloClient.mutate({
                mutation: ADD_SALES_PROFILE_COMMENTS,
                variables: commentData
            })
            return thread.thread
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addNewSalesProfileVisit({commit}, visitData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {salesRollCall}} = await apolloClient.mutate({
                mutation: ADD_SALES_PROFILE_VISITS,
                variables: visitData,
            })
            return salesRollCall.salesRollCall

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addNewSalesProfileTurnover({commit}, turnOverData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {turnOver}} = await apolloClient.mutate({
                mutation: ADD_SALES_PROFILE_TURNOVER,
                variables: turnOverData
            })
            return turnOver.turnOver
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async changeSalesProfileOwnership({commit}, ownershipData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {feedbackOwnership}} = await apolloClient.mutate({
                mutation: CHANGE_SALES_PROFILE_OWNERSHIP,
                variables: ownershipData,
            })
            return feedbackOwnership.feedbackOwnership

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async updateCustomerStatus({commit}, customerData) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            let {data: {institutionStatus}} = await apolloClient.mutate({
                mutation: UPDATE_CUSTOMER_STATUS,
                variables: customerData,
            })
            return institutionStatus.institution
        } catch(e) {
            commit('SET_ERRORS', e.graphQLErrors)
        } finally {
            commit('LOADING_FALSE')
        }
    }
}
export const mutations = {
    LOADING_TRUE(state){
        state.loading = true
    },
    LOADING_FALSE(state){
        state.loading = false
    },
    SET_ERRORS(state, payload){
        state.errors = payload
    },
    REMOVE_ERRORS(state){
        state.errors = []
    }
}


